import React from 'react';
import { styled } from '@nykaa/ui-components';
import { useTheme } from 'emotion-theming';
import { useHistory, useLocation } from 'react-router-dom';
import SearchIcon from './SearchIcon';
import { useIsConfigHeader, useIsThemeHeader } from 'hooks/header';
import { getSearchURL } from 'components/Header/Search/helper';
import { getFillColor } from 'components/Header/helper';
import { pushData } from '@nykaa/data-layer';

const SearchLink = styled.div`
  background: transparent;
  border: none;
  width: 48px;
  height: 48px;
  padding: 12px;
`;

const Search = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const theme: Theme = useTheme();
  const isThemeHeader = useIsThemeHeader();
  const { headerTextColor } = useIsConfigHeader();
  const fillColor = getFillColor(headerTextColor, isThemeHeader, theme);
  const redirectToQueryPage = () => {
    const redirectUrl = getSearchURL(pathname);
    history.push(redirectUrl);
    pushData({
      spaPageView: Date.now(),
      event: 'spaPageView',
      pageType: 'searchQueryPage',
    });
  };
  return (
    <SearchLink onClick={redirectToQueryPage}>
      <SearchIcon
        fillColor={fillColor}
        fillOpacity="1"
      />
    </SearchLink>
  );
};

export default Search;
